import React from 'react'
import { KnowledgeBase, Settings } from '@siftscience/focus-components/icons'
import HeaderMenu from './header-menu'

import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined'
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline'
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined'
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone'
import FindInPageOutlinedIcon from '@material-ui/icons/FindInPageOutlined'
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined'
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined'
import StorageOutlineIcon from '@material-ui/icons/StorageOutlined'
import DeviceHubIcon from '@material-ui/icons/DeviceHub'
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft'
import { useCurrentUser } from '../../contexts/CurrentUserContext'
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext'

const insertIf = (condition, ...elements) => (condition ? elements : [])

const TOOLTIP_TITLE = 'User menu'

const UserMenu = () => {
  const { currentUser } = useCurrentUser()
  const { imageLibrary } = useFeatureFlags()

  const menuItems = [
    {
      href: '/log_out',
      text: 'Log Out',
      icon: <ExitToAppIcon />
    },
    {
      href: `/users/${currentUser.id}/edit`,
      text: 'Account Settings',
      icon: <AccountCircleOutlinedIcon />
    },
    {
      href: '/manage_merchant_users',
      text: 'Manage team',
      icon: <PeopleOutlineIcon />
    },
    ...insertIf(currentUser.clientId, {
      href: `/clients/${currentUser.clientId}`,
      text: 'Billing',
      icon: <ReceiptOutlinedIcon />
    }),
    {
      href: '/notification_subscriptions',
      text: 'Notifications',
      icon: <NotificationsNoneIcon />
    },
    {
      href: `/users/${currentUser.id}/evidence`,
      text: 'Configure evidence',
      icon: <FindInPageOutlinedIcon />
    },
    { href: '/tags', text: 'Configure tags', icon: <LocalOfferOutlinedIcon /> },
    {
      href: `/users/${currentUser.id}/business_summary`,
      text: 'Business summary',
      icon: <BusinessOutlinedIcon />
    },
    ...insertIf(currentUser.admin || imageLibrary, {
      href: '/ui/image-library',
      text: 'Image Library',
      icon: <KnowledgeBase />
    }),
    ...insertIf(!currentUser.chargebackEmployee, {
      href: '/connections',
      text: 'Add connections',
      icon: <StorageOutlineIcon />
    }),
    ...insertIf(currentUser.admin, {
      href: '/ui/disputebot',
      text: 'Disputebot Rules',
      icon: <DeviceHubIcon />
    }),
    ...insertIf(currentUser.admin, {
      href: '/ui/template-tooling',
      text: 'Template Tooling',
      icon: <FormatAlignLeftIcon />
    })
  ]

  return (
    <HeaderMenu
      IconComponent={Settings}
      menuItems={menuItems}
      popupId="user"
      tooltipTitle={TOOLTIP_TITLE}
    />
  )
}

export default UserMenu
